import { AuthLayout } from "../authentication/layout"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useEffect } from "react"
import { AppRoutePaths } from "@/routing/route_paths"
import { purgeStore } from "@/storage/store"

export default function SSOLogoutPage() {
    const { t: translate } = useTranslation()
    const navigate = useNavigate()
  
    useEffect(() => {
        purgeStore()
        navigate(AppRoutePaths.auth.login, { replace: true })
    }, [])
  
    return (
      <AuthLayout>
        <AuthLayout.Content className="space-y-14">
          <div className="text-center text-sm text-gray-500 py-12">
            {translate('authenticating')}
          </div>
        </AuthLayout.Content>
      </AuthLayout>
    )
}